"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dateField: String,
    navigator: Object
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts-vue-wrapper/dist/es/KendoStockChart/StockChartProps.js
// module id = 695
// module chunks = 0